<template>
  <div class="start-game">
    <nav-bar
      fixed
      z-index="99"
      :title="
        gameStatus == 1
          ? !form.successSaveUser.includes(form.roleTab)
            ? '正在游戏'
            : '卡牌沟通'
          : '游戏详情'
      "
      left-text="返回"
      left-arrow
      placeholder
      @click-left="$router.push('/game/my')"
    />
    <div class="start-game-info">
      <div class="start-game-info-title">{{ gameInfo.gameName }}</div>
      <nf-card borderInnerSize="0" bgColor="#fff">
        <div class="start-game-info-card">
          <img
            class="start-game-info-card-avatar"
            :src="userInfo.avatar"
            alt=""
          />
          <div class="start-game-info-card-des">
            <div class="start-game-info-card-des-name">
              {{ userInfo.nickname }}
            </div>
            <div class="start-game-info-card-des-text"></div>
          </div>
        </div>
      </nf-card>
    </div>
    <div class="start-game-step">
      <div
        class="start-game-step-header"
        :style="
          gameStatus == 1
            ? 'transform: translateY(-20%)'
            : 'transform: translateY(-35%)'
        "
      >
        <div
          class="start-game-step-header-tab"
          v-show="form.playerList.length > 1"
        >
          <div
            v-for="item in form.playerList"
            :key="item.id"
            class="start-game-step-header-tab-item"
            :class="{ active: form.roleTab == item.id }"
            @click="changeTab(item)"
          >
            {{ item.nickName }}
          </div>
        </div>
        <!-- <nf-card :round="gameType != 5 ? '.5rem' : '0'" bgColor="#fff"> -->
        <nf-card bgColor="#fff" v-show="gameStatus == 1">
          <div class="start-game-step-header-info">
            <div class="start-game-step-header-info-left">
              正在玩：
              <!-- {{ gameInfo.cateName ? "{" + gameInfo.cateName + "}" : "" }}的{{
                gameInfo.secondCateName
                  ? "{" + gameInfo.secondCateName + "}"
                  : "游戏"
              }} -->
              <span style="font-weight: bold">{{ gameInfo.cateName }}</span>
              的
              <span style="font-weight: bold"
                >{{
                  gameInfo.secondCateName ? gameInfo.secondCateName : "游戏"
                }}
              </span>
            </div>
            <div class="start-game-step-header-info-right">
              <RadioGroup
                v-model="sizeType"
                class="start-game-step-header-info-right-radio"
                v-show="
                  gameInfo.gameType == 6 &&
                  !form.successSaveUser.includes(form.roleTab)
                "
              >
                <Radio name="big">
                  大
                  <template #icon="props">
                    <VanImage
                      :src="props.checked ? activeIcon : inactiveIcon"
                      width="15"
                      height="15"
                    />
                  </template>
                </Radio>
                <Radio name="middle">
                  中
                  <template #icon="props">
                    <VanImage
                      :src="props.checked ? activeIcon : inactiveIcon"
                      width="15"
                      height="15"
                    />
                  </template>
                </Radio>
                <Radio name="small">
                  小
                  <template #icon="props">
                    <VanImage
                      :src="props.checked ? activeIcon : inactiveIcon"
                      width="15"
                      height="15"
                    />
                  </template>
                </Radio>
              </RadioGroup>
            </div>
          </div>
        </nf-card>
      </div>
      <div class="start-game-step-content">
        <template
          v-if="!form.successSaveUser.includes(form.roleTab) && isUserCard"
        >
          <div v-show="gameStatus == 1">
            <Game2
              v-if="gameInfo.gameType == 2"
              :value.sync="form"
              :cardList="cardList"
              :gameInfo="gameInfo"
              :userInfo="userInfo"
              :sizeType="sizeType"
              :gameStatus="gameStatus"
              @confirm="saveRecord"
            />
            <Game3
              ref="game3Ref"
              v-if="gameInfo.gameType == 3"
              :cardList="cardList"
              :value.sync="form"
              :gameInfo="gameInfo"
              :userInfo="userInfo"
              :sizeType="sizeType"
              :gameStatus="gameStatus"
              :game3List.sync="game3List"
              :game3Lock="game3Lock"
              :frontSelectCardList="form.frontSelectCardList"
              @confirm="saveRecord"
            />
            <Game4
              v-if="gameInfo.gameType == 4"
              :cardList="cardList"
              :value.sync="form"
              :gameInfo="gameInfo"
              :userInfo="userInfo"
              :sizeType="sizeType"
              :gameStatus="gameStatus"
              @confirm="saveRecord"
            />
            <Game6
              v-if="gameInfo.gameType == 6"
              :cardList="cardList"
              :value.sync="form"
              :gameInfo="gameInfo"
              :userInfo="userInfo"
              :sizeType="sizeType"
              :gameStatus="gameStatus"
              @confirm="saveRecord"
            />
          </div>
        </template>

        <template v-else>
          <Discus1
            v-show="gameStatus == 1"
            :value.sync="form"
            :flip="flip"
            :gameStatus="gameStatus"
            :gameInfo="gameInfo"
          />
        </template>

        <!-- 之前的选择 -->
        <FrontSelectList :value.sync="form.frontSelectCardList" />
      </div>
    </div>
  </div>
</template>

<script>
import NfCard from "@/components/game-ui/NfCard.vue";
import FrontSelectList from "@/components/game-comm/FrontSelectList.vue";
import { RadioGroup, Radio, Image as VanImage, Popup, NavBar } from "vant";
import activeIcon from "@/assets/game/checked.png";
import inactiveIcon from "@/assets/game/no_checked.png";
import Game2 from "./components/game-2.vue";
import Game3 from "./components/game-3.vue";
import Game4 from "./components/game-4.vue";
import Game6 from "./components/game-6.vue";
import Discus1 from "./components/discus-1.vue";
import Test from "./components/test.vue";
import {
  getCardList,
  getPlayerList,
  gameRecordSave,
  getGameRecord,
  getRoundConfig,
} from "@/api/game";
import ws from "@/utils/ws";
import { getGameConfigByTag, getGameConfig } from "../config";
import cookie from "@utils/store/cookie";

export default {
  components: {
    Popup,
    NfCard,
    RadioGroup,
    Radio,
    VanImage,
    Game2,
    Game3,
    Game4,
    Test,
    Game6,
    Discus1,
    FrontSelectList,
    NavBar,
  },
  async mounted() {
    this.gameInfo = this.$route.query;
    this.changeGame();
    this.userInfo = this.$store.state.app.userInfo;
    // 同步当前用户的uid
    this.form.roleTabUid = this.userInfo.uid;
    // 初始化获取玩家列表
    this.getPlayerList().then((res) => {
      //初始化第一个选择的玩家为选中状态
      this.form.roleTab = res[0].id;
      this.checkFlip();
      // 初始化玩家选择的卡牌列表
      this.form.playerList.forEach((item) => {
        this.form.playerCardList[item.id] = [];
      });
    });
    // 获取当前游戏信息，如当前最多抽卡次数
    await this.getGameInfo();
    // 初始化获取卡牌列表
    this.getCardList();
  },
  data() {
    return {
      sizeType: "big",
      activeIcon,
      inactiveIcon,
      // 1：价值观卡的图画
      gameType: 3,
      gameStatus: 1,
      // 所有卡牌列表
      cardList: [],
      // 打分列表
      game3List: [
        {
          name: "同伴",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(255, 129, 129)",
          borderColor: "rgba(255, 129, 129)",
        },
        {
          name: "异性",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(255, 195, 125)",
          borderColor: "rgba(255, 195, 125, 2)",
        },
        {
          name: "老师",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(92, 211, 231)",
          borderColor: "rgba(92, 211, 231)",
        },
        {
          name: "学习",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(255, 215, 39)",
          borderColor: "rgba(255, 215, 39)",
        },
        {
          name: "自我",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(97, 216, 81)",
          borderColor: "rgba(97, 216, 81)",
        },
        {
          name: "兴趣",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(193, 169, 253)",
          borderColor: "rgba(193, 169, 253)",
        },
        {
          name: "娱乐",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(230, 118, 247)",
          borderColor: "rgba(230, 118, 247)",
        },
        {
          name: "家庭",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(110, 144, 255)",
          borderColor: "rgba(110, 144, 255)",
        },
        {
          name: "偶像",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(93, 193, 156)",
          borderColor: "rgba(93, 193, 156)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(255, 129, 129)",
          borderColor: "rgba(255, 129, 129)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(155, 109, 129)",
          borderColor: "rgba(155, 109, 129)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(55, 129, 119)",
          borderColor: "rgba(55, 129, 119)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(155, 29, 129)",
          borderColor: "rgba(155, 29, 129)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(5, 129, 19)",
          borderColor: "rgba(5, 129, 129)",
        },
      ],
      userInfo: {},
      gameInfo: {
        gameId: 1,
        gameRoundId: 1,
        cateId: 4,
        secondCateId: 5,
      },
      form: {
        // 玩家选择的角色
        roleTab: 0,
        // tab所属用户的uid
        roleTabUid: 0,
        selectCardList: [],
        // 所有玩家列表
        playerList: [],
        // 玩家选择的卡牌列表
        playerCardList: {},
        // 成功保存后的用户
        successSaveUser: [],
        // 当前所有的游戏记录
        gameRecordList: [],
        // 我之前的选择
        frontSelectCardList: [],
      },
      // 动态匹配是否可以翻牌
      flip: false,
      ws: null,
      game3Lock: false,
    };
  },
  methods: {
    wsMessage(data) {
      const dataJson = data;
      // 教练重新发牌，进入下一轮游戏
      if (dataJson.type == 4) {
        // this.$router.push({
        //   url: "/game/start",
        //   query: {
        //     gameId: dataJson.gameId,
        //     gameRoundId: dataJson.gameRoundId,
        //     cateId: dataJson.cateId,
        //     secondCateId: dataJson.secondCateId,
        //   },
        // });

        window.location.href = `/game/start?gameId=${dataJson.gameId}&gameRoundId=${dataJson.gameRoundId}&cateId=${dataJson.cateId}&secondCateId=${dataJson.secondCateId}`;
      }
      // 结束游戏，退出
      if (dataJson.gameStatus == 2) {
        this.$dialog.message("游戏结束");
        this.$router.push({
          path: "/game/my",
        });
      }
      // 教练点击了翻面，用户端同步
      if (dataJson.type == 5) {
        this.checkFlip();
      }
      // 如果获取到的玩家人数比现有人数高，则刷新玩家列表
      if (dataJson.playerNum >= this.form.playerList) {
        this.$toast("有新玩家加入，正在刷新列表");
        // 初始化获取玩家列表
        this.getPlayerList().then((res) => {
          //初始化第一个选择的玩家为选中状态
          this.form.roleTab = res[0].id;
          this.checkFlip();
          // 初始化玩家选择的卡牌列表
          this.form.playerList.forEach((item) => {
            this.form.playerCardList[item.id] = [];
          });
        });
      }
    },
    // 获取卡牌列表
    getCardList() {
      const data = {
        gameId: this.gameInfo.gameId,
        cateId: this.gameInfo.cateId,
        secondCateId: this.gameInfo.secondCateId,
        // cateId: 4,
        // secondCateId: 5,
      };
      getCardList(data).then((res) => {
        if (res.success) {
          this.cardList = res.data;
          // 如果为暗抽、九宫格，随机抽9张牌

          // 如果为盲抽，抽25张牌
          if (
            this.gameInfo.secondCateId == 11 ||
            this.gameInfo.secondCateId == 16
          ) {
            // 随机25张
            this.cardList = this.cardList.sort(() => {
              return Math.random() - 0.5;
            });
            this.cardList = this.cardList.slice(0, 25);
          }
        }
      });
    },
    // 获取玩家列表
    getPlayerList() {
      return new Promise((resolve, reject) => {
        getPlayerList({ gameId: this.gameInfo.gameId })
          .then((res) => {
            if (res.success) {
              this.form.playerList = res.data.map((item) => {
                return {
                  ...item,
                  brandStatus: false,
                };
              });

              resolve(res.data);
            } else {
              reject();
            }
          })
          .catch(() => {
            reject();
          });
      });
    },
    // 保存玩家数据
    saveRecord(data) {
      const form = {
        roundId: this.gameInfo.gameRoundId,
        userId: this.userInfo.uid,
        gameId: this.gameInfo.gameId,
        records: data,
      };
      gameRecordSave(form)
        .then((res) => {
          if (res.success) {
            this.$dialog.message("记录成功");
            this.form.successSaveUser.push(this.form.roleTab);
          } else {
            this.$dialog.message(res.msg);
          }
        })
        .catch((err) => {
          this.$dialog.message(err.msg);
        });
    },
    // 获取游戏记录
    getGameRecord(playerId) {
      this.$dialog.loading.open("用户数据加载中...");
      return new Promise((resolve, reject) => {
        getGameRecord(this.gameInfo.gameId, playerId)
          .then((res) => {
            if (res.success) {
              this.form.gameRecordList = res.data;
              resolve(res.data);
            } else {
              reject(res);
            }
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            this.$dialog.loading.close();
          });
      });
    },
    // 获取当前游戏信息
    getGameInfo() {
      return new Promise((resolve, reject) => {
        getRoundConfig({ gameId: this.gameInfo.gameId })
          .then((res) => {
            if (res.success) {
              Object.assign(this.gameInfo, res.data.cardGameRound);
              this.gameInfo.gameRoundId = res.data.cardGameRound.id;
              this.gameInfo.gameName = res.data.gameName;
              this.gameInfo.openSync = res.data.cardGameRound.openSync;
              this.gameInfo.gameStatus = res.data.gameStatus;
              // 游戏是开始状态才简历连接
              if (res.data.gameStatus == 1) {
                // 开启socket监听
                // this.requstWs(this.userInfo.uid, this.gameInfo.gameId);
                this.ws = new ws({
                  url: `/game/${this.gameInfo.gameId}/${this.userInfo.uid}`,
                  //心跳时间（单位:ms）
                  heartBeat: 5000,
                  //发送心跳信息（支持json传入）
                  heartMsg: {
                    roomId: this.gameInfo.gameId,
                    userId: this.userInfo.uid,
                    heartbeat: "ping",
                  },
                  //开起重连
                  reconnect: true,
                  //重连间隔时间（单位:ms）
                  reconnectTime: 5000,
                  //重连次数
                  reconnectTimes: 5,
                });
                this.ws //接收信息
                  .onmessage((data) => {
                    console.log(data);
                    if (data == "pong") {
                      return;
                    }
                    this.wsMessage(JSON.parse(data));
                  });
                // socket心跳检测
                // this.checkSocketStatus();
              }
              this.gameStatus = res.data.gameStatus;

              this.changeGame();

              resolve(res.data);
            } else {
              reject();
            }
          })
          .catch((err) => {
            this.$dialog.message(err.msg);
            reject(err);
          });
      });
    },
    // 根据不同类型进入不同游戏页面
    changeGame() {
      const config = getGameConfigByTag(this.gameInfo.tag);
      Object.assign(this.gameInfo, config);
      console.log("changeGame", config, this.gameInfo.gameType);
    },
    // 检测当前用户是否可以翻牌
    checkFlip() {
      this.getPlayerList().then((res) => {
        const player = this.form.playerList.find(
          (item) => item.id == this.form.roleTab
        );
        console.log("currentPlayer", player);
        this.flip = player.isOpen;
      });
    },
    // 切换tab
    changeTab(item) {
      this.form.roleTab = item.id;
      this.form.roleTabUid = item.userId;
    },
    // 打分同步历史选中/缓存的数据
    cacheStoreGame3Handle(dataList) {
      // 优先走缓存，如果缓存没有，看看是否需要同步历史记录，就走历史记录
      const key = `${this.gameInfo.gameId}_${this.gameInfo.gameRoundId}_${this.userInfo.uid}_${this.form.roleTab}`;
      let storeData = JSON.parse(localStorage.getItem(key)) || [];
      // 走缓存
      if (storeData && storeData != null && storeData.length > 0) {
        console.log("走cookie缓存数据1");
        // 遍历gameList，将value设置为data中的value
        // this.game3List.map((item, index) => {
        //   const findIndex = storeData.findIndex((subitem) => {
        //     return subitem.name == item.name;
        //   });
        //   console.log("修改", findIndex, [...storeData], item.name);
        //   if (findIndex > -1) {
        //     item.value = storeData[findIndex].value;
        //   } else {
        //     item.value = 0;
        //   }
        // });
        this.game3List.map((item, index) => {
          // const findIndex = storeData.findIndex((subitem) => {
          //   return subitem.name == item.name;
          // });
          console.log("修改", index, [...storeData], item.name);
          if (index > -1) {
            item.value = storeData[index].value;
          } else {
            item.value = 0;
          }
        });
      } else if (this.gameInfo.openSync == 1) {
        // 走历史记录
        dataList.sort((a, b) => {
          return b.roundNum - a.roundNum;
        });
        const findItem = dataList.find((item) => {
          if (
            item.records.length > 0 &&
            item.roundId != this.gameInfo.gameRoundId
          ) {
            return (
              item.records[0].cateId === this.gameInfo.cateId &&
              item.records[0].secondCateId === this.gameInfo.secondCateId
            );
          }
        });
        console.log("走历史记录", findItem);
        const config = getGameConfig(
          this.gameInfo.cateId,
          this.gameInfo.secondCateId
        );

        if (findItem && config.visibleType == "wheel") {
          for (let index in this.game3List) {
            // 找到名字相同的项，替换分数
            const findIndex = findItem.records.findIndex((subitem) => {
              return subitem.cardName == this.game3List[index].name;
            });
            if (findIndex > -1) {
              this.game3List[index].value =
                findItem.records[findIndex].score || 0;
            } else {
              this.game3List[index].value = 0;
            }
          }
        } else {
          // 归零
          this.game3List.map((item) => {
            item.value = 0;
          });
        }
      } else {
        // 归零
        this.game3List.map((item) => {
          item.value = 0;
        });
      }
      this.game3Lock = false;
    },
  },
  watch: {
    // 初始化卡牌记录列表
    "form.roleTab": {
      handler(val, oldVal) {
        {
          this.game3Lock = true;
          // console.log("form.roleTab", val, this.gameInfo.gameType);
          this.form.roleName = this.form.playerList.find(
            (item) => item.id == val
          ).nickName;
          // 清空之前的选择列表
          this.form.frontSelectCardList.splice(
            0,
            this.form.frontSelectCardList.length
          );
          this.getGameRecord(val).then((res) => {
            // 清空
            this.form.frontSelectCardList.splice(
              0,
              this.form.frontSelectCardList.length
            );
            for (let item of res) {
              // 判断当前游戏是否结束，结束了就不再记录，当前选择的卡牌（游戏已结束）
              // 当前轮次选择的卡牌（游戏未结束）
              // console.log("this.gameInfo", this.gameInfo);
              if (
                item.roundId == this.gameInfo.gameRoundId &&
                this.gameInfo.gameStatus == 1
              ) {
                if ((item.records || []).length > 0) {
                  // 代表当前用户已经选择过了
                  this.form.successSaveUser.push(this.form.roleTab);
                  // 写入当前王家选择的卡牌
                  this.form.playerCardList[this.form.roleTab] = item.records;
                }
              } else {
                // 之前的选择
                // this.form.frontSelectCardList.push(item.records);
                this.form.frontSelectCardList.push({
                  records: item.records,
                  roundNum: item.roundNum,
                  cateName: item.cateName,
                });
                // 根据roundNum从大到小排序
                this.form.frontSelectCardList.sort((a, b) => {
                  return b.roundNum - a.roundNum;
                });
              }
            }

            // game3的特殊处理
            if (this.gameInfo.gameType == 3) {
              this.cacheStoreGame3Handle(res || []);
            }
          });
          // 更新当前用户是否可翻牌
          this.getPlayerList().then((res) => {
            this.checkFlip();
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  // 断开链接
  beforeDestroy() {
    this.ws.close();
    this.ws.ws.close();
    this.ws = null;
    console.log("销毁ws");
  },
  computed: {
    // 当前切换到的用户是否是自己
    isUserCard() {
      return this.form.roleTabUid == this.userInfo.uid;
    },
  },
};
</script>

<style lang="scss" scoped>
.start-game {
  background: url(~@/assets/game/bg.png) 100% no-repeat;
  background-size: 100% 100%;
  width: 100%;
  position: relative;
  padding-bottom: 0.2rem;
  &-info {
    width: 100%;
    background-color: rgb(172, 185, 233);
    padding: 0.8rem 0.5rem;
    padding-top: 0rem;
    &-title {
      font-size: 0.32rem;
      // font-weight: bold;
      color: #fff;
      text-align: center;
    }
    &-card {
      display: flex;
      align-items: center;
      &-avatar {
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 0.1rem;
        margin-right: 0.2rem;
      }
      &-des {
        font-size: 0.25rem;
        &-name {
        }
      }
    }
  }
  &-step {
    width: 100%;
    &-header {
      width: 100%;

      &-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.25rem;
        color: #666;

        &-left {
        }
        &-right {
          &-radio {
            display: flex;
            align-items: center;
            .van-radio {
              margin-right: 0.2rem;
            }
          }
        }
      }
      &-tab {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.25rem;

        .active {
          background-color: rgb(255, 210, 93);
        }

        &-item {
          background-color: #fff;

          border-top-left-radius: 0.3rem;
          border-top-right-radius: 0.3rem;
          border: 0.03rem solid #666;
          width: 100%;
          text-align: center;
          padding: 0.2rem 0;
          border-bottom: 0.02rem solid #666;
        }
      }
    }
    &-content {
      padding: 0 0.1rem;
      // margin-top: -0.2rem;
    }
  }
}

::v-deep .van-nav-bar {
  background-color: rgb(172, 185, 233) !important;
}
</style>

<style>
.van-grid-item__content {
  background-color: inherit !important;
}
</style>
